exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#curriculumUpload[data-v-1d6f0581] {\n  position: absolute;\n  left: -99999px;\n}\n", ""]);

// exports
